import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {

  constructor() { }

  loadMicroFrontEnds(): void {
    if (environment.microFrontEnds && environment.microFrontEnds.length > 0) {
      environment.microFrontEnds.forEach((scriptUrl: string) => {
        this.loadScript(scriptUrl);
      });
    }
  }

  private loadScript(url: string): void {
    // Check if script is already loaded
    const existingScript = document.querySelector(`script[src="${url}"]`);
    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.src = url;
    script.type = 'module';
    script.async = true;
    document.head.appendChild(script);
  }
}
